var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1327_3452",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.478516,
    y: 0.143555,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1327_3452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8118 17.6436L11.5618 12.3936C11.1452 12.7269 10.666 12.9908 10.1243 13.1852C9.58268 13.3797 9.00629 13.4769 8.39518 13.4769C6.88129 13.4769 5.60004 12.9526 4.55143 11.904C3.50282 10.8554 2.97852 9.57411 2.97852 8.06022C2.97852 6.54633 3.50282 5.26508 4.55143 4.21647C5.60004 3.16786 6.88129 2.64355 8.39518 2.64355C9.90907 2.64355 11.1903 3.16786 12.2389 4.21647C13.2875 5.26508 13.8118 6.54633 13.8118 8.06022C13.8118 8.67133 13.7146 9.24772 13.5202 9.78939C13.3257 10.3311 13.0618 10.8102 12.7285 11.2269L17.9785 16.4769L16.8118 17.6436ZM8.39518 11.8102C9.43685 11.8102 10.3223 11.4456 11.0514 10.7165C11.7806 9.9873 12.1452 9.10189 12.1452 8.06022C12.1452 7.01855 11.7806 6.13314 11.0514 5.40397C10.3223 4.6748 9.43685 4.31022 8.39518 4.31022C7.35352 4.31022 6.4681 4.6748 5.73893 5.40397C5.00977 6.13314 4.64518 7.01855 4.64518 8.06022C4.64518 9.10189 5.00977 9.9873 5.73893 10.7165C6.4681 11.4456 7.35352 11.8102 8.39518 11.8102Z",
    fill: "#28398A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.39518 11.8102C9.43685 11.8102 10.3223 11.4456 11.0514 10.7165C11.7806 9.9873 12.1452 9.10189 12.1452 8.06022C12.1452 7.01855 11.7806 6.13314 11.0514 5.40397C10.3223 4.6748 9.43685 4.31022 8.39518 4.31022C7.35352 4.31022 6.4681 4.6748 5.73893 5.40397C5.00977 6.13314 4.64518 7.01855 4.64518 8.06022C4.64518 9.10189 5.00977 9.9873 5.73893 10.7165C6.4681 11.4456 7.35352 11.8102 8.39518 11.8102Z",
    fill: "#28398A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchFilled);
export default __webpack_public_path__ + "static/media/search_filled.9adc5b6ee933f50269014a34c8a75f37.svg";
export { ForwardRef as ReactComponent };